module.exports = __webpack_public_path__ + "img/web_5.41da83e2.webp";